import React from 'react'

export default function LinearProgressBar({ progress = 0, bgColor = 'black', height = '12px'}) {
    const parentdiv = {
        height: height,
        width: '100%',
        background: '#E5E4E2',
        borderRadius: 40,
      }
     
      const childdiv = {
        height: '100%',
        width: progress + "%",
        background: bgColor,
        borderRadius:40,
        textAlign: 'right',
        transition : 'all 0.3s ease'
      }
       
    return (
    <div style={parentdiv}>
      <div style={childdiv}>
         
      </div>
    </div>
    )
}
